export { gmapGilson };

const gmapGilson = () => {
  jQuery(document).ready(function ($) {
    if ($("#map-gilson")) {
      // Create the script tag, set the appropriate attributes
      const apiKey = "AIzaSyC70TVRqrim_uHIAPFtC1tWniMiSATMVl8";

      const script = document.createElement("script");
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=" +
        apiKey +
        "&callback=initMap";
      script.async = true;

      window.initMap = function () {
        const defaultPos = { lat: 50.4604, lng: 4.85631 };

        const mapOptions = {
          maxZoom: 17,
          zoom: 20,
          disableDefaultUI: 0,
          zoomControl: 1,
          center: defaultPos,
          mapTypeId: "roadmap",
          styles: getStyleMap(),
        };

        const map = new google.maps.Map(
          document.getElementById("map-gilson"),
          mapOptions
        );

        const bounds = new google.maps.LatLngBounds();

        map.fitBounds(bounds);

        const pos = {
          lat: 50.4604,
          lng: 4.85631,
        };

        new google.maps.Marker({
          position: pos,
          map: map,
          title: "Gilson",
        });

        if (document.getElementById("gmap-contact") != null) {

          const mapContact = new google.maps.Map(
            document.getElementById("gmap-contact"),
            mapOptions
          );

          mapContact.fitBounds(bounds);

          new google.maps.Marker({
            position: pos,
            map: mapContact,
            title: "Gilson",
          });
        }

        bounds.extend(pos);

        function getStyleMap() {
          return [
            {
              featureType: "all",
              elementType: "labels.text.fill",
              stylers: [
                {
                  saturation: 36,
                },
                {
                  color: "#333333",
                },
                {
                  lightness: 40,
                },
              ],
            },
            {
              featureType: "all",
              elementType: "labels.text.stroke",
              stylers: [
                {
                  visibility: "on",
                },
                {
                  color: "#ffffff",
                },
                {
                  lightness: 16,
                },
              ],
            },
            {
              featureType: "all",
              elementType: "labels.icon",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "administrative",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#fefefe",
                },
                {
                  lightness: 20,
                },
              ],
            },
            {
              featureType: "administrative",
              elementType: "geometry.stroke",
              stylers: [
                {
                  color: "#fefefe",
                },
                {
                  lightness: 17,
                },
                {
                  weight: 1.2,
                },
              ],
            },
            {
              featureType: "administrative.country",
              elementType: "geometry.stroke",
              stylers: [
                {
                  color: "#a1a1a1",
                },
              ],
            },
            {
              featureType: "administrative.province",
              elementType: "geometry.stroke",
              stylers: [
                {
                  color: "#a1a1a1",
                },
                {
                  lightness: "0",
                },
                {
                  weight: "1.10",
                },
              ],
            },
            {
              featureType: "administrative.locality",
              elementType: "geometry.fill",
              stylers: [
                {
                  invert_lightness: true,
                },
              ],
            },
            {
              featureType: "landscape",
              elementType: "geometry",
              stylers: [
                {
                  color: "#f5f5f5",
                },
                {
                  lightness: 20,
                },
              ],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [
                {
                  color: "#f5f5f5",
                },
                {
                  lightness: 21,
                },
              ],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [
                {
                  color: "#dedede",
                },
                {
                  lightness: 21,
                },
              ],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.fill",
              stylers: [
                {
                  color: "#e0e0e0",
                },
                {
                  lightness: 17,
                },
              ],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [
                {
                  color: "#ffffff",
                },
                {
                  lightness: 29,
                },
                {
                  weight: 0.2,
                },
              ],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [
                {
                  color: "#ffffff",
                },
                {
                  lightness: 18,
                },
              ],
            },
            {
              featureType: "road.local",
              elementType: "geometry",
              stylers: [
                {
                  color: "#ffffff",
                },
                {
                  lightness: 16,
                },
              ],
            },
            {
              featureType: "road.local",
              elementType: "geometry.stroke",
              stylers: [
                {
                  visibility: "simplified",
                },
                {
                  hue: "#ff0000",
                },
              ],
            },
            {
              featureType: "transit",
              elementType: "geometry",
              stylers: [
                {
                  color: "#f2f2f2",
                },
                {
                  lightness: 19,
                },
              ],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [
                {
                  color: "#e9e9e9",
                },
                {
                  lightness: 17,
                },
              ],
            },
          ];
        }
      };
      // Append the 'script' element to 'head'
      document.head.appendChild(script);
    }
  });
};
